<template>
  <div v-if="showBanner" class="support-banner">
    <NrIcon
      class="support-banner-icon"
      name="exclamation-triangle"
      iconType="solid"
    />

    <div class="support-banner-text">
      <h4>{{ header }}</h4>
      <p v-html="messageHtml"></p>
    </div>
    <NrIconButton
      class="support-banner-close"
      :icon="{ name: 'times', type: 'regular' }"
      variant="filled"
      size="small"
      aria-label="Dismiss banner"
      @click="dismissBanner"
    />
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import API from 'src/vue_shared/api'
import { useCookies } from 'vue3-cookies'
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'

const { cookies } = useCookies()
const isDeployed = ref(false)
const dismissed = ref(false)
const header = ref('')
const messageHtml = ref('')

const showBanner = computed(() => isDeployed.value && !dismissed.value)

async function fetchBannerConfig() {
  const { data } = await API.fetchSupportBanner()

  const dismissedAt = cookies.get('supportBannerDismissedAt')
  isDeployed.value = data.is_deployed || false
  header.value = data.header
  messageHtml.value = data.message_html

  if (!dismissedAt) {
    dismissed.value = false
  } else if (
    data.refresh_dismissed &&
    Date.parse(data.updated_at) > Date.parse(dismissedAt)
  ) {
    dismissed.value = false
  } else if (dismissedAt) {
    dismissed.value = true
  }
}

function dismissBanner() {
  dismissed.value = true
  // Setting to zero makes it expire with the session
  cookies.set(
    'supportBannerDismissedAt',
    new Date().toISOString().toString(),
    0
  )
}

onMounted(fetchBannerConfig)
</script>
<style scoped lang="scss">
@import '@nextrequestco/components/src/styles/colors.scss';
@import '@nextrequestco/components/src/styles/tokens/variables.scss';

.support-banner {
  display: flex;
  align-items: flex-start;
  padding: $spacing-12 $spacing-16;
  font-family: inherit;
  font-size: 14px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 12px;
    height: 100%;
    background-color: #ffba46;
  }
}

.support-banner-icon {
  width: $size-large;
  height: $size-large;
  font-size: $size-large;
  color: #ffba46;
  flex-shrink: 0;
}
.support-banner-text {
  margin-left: $spacing-12;
  flex: 1 0 0;
  flex-direction: column;
}
.support-banner-text h4 {
  font-size: $font-size-6;
  font-style: normal;
  font-weight: $font-weight-regular;
  line-height: normal;
}
.support-banner-text p {
  margin-top: $spacing-4;
  font-size: $font-size-2;
  font-style: normal;
  font-weight: $font-weight-regular;
  line-height: normal;
}
.support-banner-close {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  background: none;
  border: none;
  font-size: $size-small;
  cursor: pointer;
  line-height: 1;
}
</style>
